import { css } from 'lit';
export default css `
  :host {
    display: block;
  }

  .selector {
    display: flex;
    align-items: center;
  }

  .selector__label {
    flex: 0 0 auto;
    width: 84px;
    padding-bottom: 20px;
  }

  .selector__select {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    width: 100%;
  }

  .selector__button--left {
    margin-right: 6px;
  }

  .selector__button--right {
    margin-left: 6px;
  }

  .item-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1px 7px 9px;
  }

  .item-container:first-of-type {
    margin-left: 0px;
  }

  .item {
    box-sizing: border-box;
    width: var(--private-item-width);
    height: var(--private-item-height);
    /* There is an additional 1px margin to secure the space for +1px of hover/selected shadow */
    border-radius: var(--amityeko-radius-small);
    object-fit: cover;
    border: 1px solid var(--amityeko-color-gray-8);
    cursor: pointer;
  }

  .item--bgimage {
    background-image: var(--private-bg-image);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .item--gradient {
    background: linear-gradient(
      197.39deg,
      var(--private-from-color) 0%,
      var(--private-to-color) 100%
    );
  }

  .item-container--selected .item,
  .item:hover {
    border: 1px solid var(--amityeko-color-primary-6);
    /* If we would change size of border - image gonna scale. */
    box-shadow: 0px 0px 0px 1px var(--amityeko-color-primary-6);
  }

  .item__name {
    color: var(--amityeko-color-gray-3);
  }
`;
//# sourceMappingURL=styles.js.map